export default __webpack_public_path__ + "static/media/icon.wet wipes.8e7a726e.svg";